module.exports = new __parcel__URL__("template-roadmap-icon.2e1e7814.svg").toString();